export default {
  algoz: [
    {
      name: "VITALINO NEVES – Raçoes",
      address: "Rua do Alto do Palmeiral",
    },
    {
      name: "Oliveira's Bar",
      address: "Poço do Gueno",
    },
  ],
  tunes: [],
  armpera: [],
  pera: [
    {
      name: "Jose F. M. do Carmo",
      address: "Rua Alexandre Herculano Nº46",
    },
    {
      name: "Agrimal Rações",
      address: "Beco dos Pinheiros",
    },
  ],
  serra: [
    {
      name: "Drogaria 'A Nova'",
      address: "Rua Largo da Fabrica Velha, Nº1",
    },
    {
      name: "Auzenda Vieira Unipessoal, Lda",
      address: "Rua da Igreja Nº16",
    },
    {
      name: "Cestinho de Compras",
      address: "Rua do Comercio Nº14",
    },
    {
      name: "Andre Miguel Guerreiro Coelho",
      address: "Azilheira",
    },
  ],
  paderne: [],
  alcantarilha: [],
  silves: [
    {
      name: "Café Retiro dos Pescadores",
      address: "Sitio da Pedreira",
    },
    {
      name: "RG Raçoes Lda",
      address: "Ladeira de S. Pedro",
    },
    {
      name: "Pastelaria Canivete",
      address: "Rua Dr. Jose Julio Martins, Enxerim",
    },
    {
      name: "Mini Mercado Terruta",
      address: "Rua cruz de Portugal Nº39",
    },
  ],
  messines: [
    {
      name: "VITALINO NEVES - Supermercado Coviram",
      address: "Rua Principal da Amorosa",
    },
    {
      name: "Mini Mercado Naicinha",
      address: "Rua Luis de Camoes, Nº5",
    },
    {
      name: "Mini Mercado Fatima",
      address: "Rua Antonio Aleixo nº17",
    },
    {
      name: "Café o Jorge",
      address: "Rua Joao De Deus nº 121",
    },
    {
      name: "Supermercado - Grilo Henriques Lda",
      address: "Rua da Liberdade",
    },
    {
      name: "Cantinho da Adelaide",
      address: "Rua da Junqueira nº5",
    },
    {
      name: "Eurico Martins Mealha",
      address: "Rua T. C. Jorge V. Mogo",
    },
    {
      name: "Messitalhos Lda",
      address: "Rua da Liberdade Nº30",
    },
    {
      name: "Casa Das Rações",
      address: "Aldeia Ruiva",
    },
    {
      name: "Tasca Beira Serra",
      address: "Fonte Joao Luis",
    },
    {
      name: "Guia & Pires Lda",
      address: "Assumadas",
    },
    {
      name: "JOSE MARTINS COELHO LDA",
      address: "Casa da Corte - Alte",
    },
  ],
  albufeira: [
    { name: "Drogaria Pedro Martins", address: "Rua Jornal A Avezinha" },
    { name: "Bar Nortenho", address: "Rua Alves Redol" },
    { name: "Graça", address: "Praceta Das Flores" },
    { name: "Posto Combustivel BP", address: "Avenida dos Descobrimentos" },
    {
      name: "Papelaria Numeros Animados",
      address: "Beco das Perdizes (McDonald)",
    },
    { name: "Intermarché Albufeira", address: "Cerro Grande" },
    { name: "Celeiro da Branqueira", address: "Estrada M526 (Branqueira)" },
    { name: "Mini Mercado Otilia Vieira", address: "Estrada dos Cerros Altos" },
  ],
  olhosagua: [
    { name: "Minimercado Vieira", address: "Estrado do Toy 70" },
    { name: "Café Hamburgo", address: "Estrada do Toy 70" },
    { name: "Snack Bar O Berto", address: "Estrada das Açoteias M1289" },
    { name: "Supermercado Mira Parque - Coviran", address: "Estrada das Açoteias M1289" },
  ],
  guia: [
    { name: "Supermercado Castelo (Spar)", address: "Estrada do Castelo" },
    { name: "Oceano Supermercados", address: "Estrada M526 (Patroves)" }
  ],
  ferreiras: [
    { name: "Drogaria Lacosalagarve", address: "Tominhal" },
    { name: "BP Ferreiras", address: "Av. 12 Julho" },
  ],
};
